var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"rate-stars review__rating"},_vm._l((_vm.stars),function(star,i){return _c('li',{key:i,staticClass:"star",class:{
					'active': star,
					'empty': !star
				}},[_c('svg',{attrs:{"viewBox":"0 0 25 25"}},[_c('use',{attrs:{"xlink:href":"#star"}})])])}))}
var staticRenderFns = []

export { render, staticRenderFns }